import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { SWRConfig } from "swr";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import "./css/index.css";
import { StyledEngineProvider } from "@mui/material/styles";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import App from "./App";

import theme from "./theme";
import { createRoot } from "react-dom/client";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  tracesSampleRate: 0.2,
  enabled: process.env.NODE_ENV === "production",
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <>
    <HelmetProvider>
      <Helmet defaultTitle="Spiffy" />

      <StyledEngineProvider injectFirst>
        <StyledThemeProvider theme={theme}>
          <MuiThemeProvider theme={theme}>
            <SWRConfig value={{ errorRetryCount: 2 }}>
              <Router>
                <App />
              </Router>
            </SWRConfig>
          </MuiThemeProvider>
        </StyledThemeProvider>
      </StyledEngineProvider>
    </HelmetProvider>
  </>,
);
